export const UPDATE_ENV = 'UPDATE_ENV';
export const UPDATE_TOTAL = 'UPDATE_TOTAL';
export const UPDATE_PAYMENT_REQUEST_DATA = 'UPDATE_PAYMENT_REQUEST_DATA';
export const RESET_PAYMENT_REQUEST_DATA = 'RESET_PAYMENT_REQUEST_DATA';
export const UPDATE_TOTAL_TO_MINOR = 'UPDATE_TOTAL_TO_MINOR';
